/* eslint-disable react/react-in-jsx-scope */
import * as Yup from 'yup';

export const FAQValidationSchema = Yup.object({
  question: Yup.string('Enter the Question')
    .max(200, 'Question should be less than 200 characters')
    .required('Question is required')
    .trim(),
  answer: Yup.string('Enter the Answer')
    .max(1000, 'Answer should be less than 2000 characters')
    .required('Answer is required')
    .trim(),
  faqCategory: Yup.object('').required('FAQ Category is required').nullable(),
});

export const NEWSValidationSchema = Yup.object({
  settingValue: Yup.string('Enter the News value')
    .max(100, 'News should be less than 100 characters')
    .required('News is required')
    .trim(),
});

export const FAQColumns = [
  {
    accessorKey: 'question',
    header: 'FAQ',
    cell: ({ row }) => (
      <div key={row?.original?.id}>
        <div className="f-12 fw-semibold">
          {row?.original?.question
            ? `${row?.original?.question}`
            : 'Not Available'}
        </div>
        <div className="f-12 text-active fw-medium">
          {row?.original?.answer ? `${row?.original?.answer}` : 'Not Available'}
        </div>
      </div>
    ),
    enableSorting: true,
  },
  { accessorKey: 'actions', header: '', enableSorting: false },
];

export const NEWSColumns = [
  {
    accessorKey: 'settingValue',
    header: 'News',
    cell: ({ row }) => (
      <div key={row?.original?.id}>
        {/* <div className="f-12 fw-semibold">
          {row?.original?.question
            ? `${row?.original?.question}`
            : 'Not Available'}
        </div> */}
        <div className="f-12 text-active fw-medium">
          {row?.original?.settingValue
            ? `${row?.original?.settingValue}`
            : 'Not Available'}
        </div>
      </div>
    ),
    enableSorting: false,
  },
  { accessorKey: 'actions', header: '', enableSorting: false },
];
